import { IEnvironment } from './environment.interface';

// eslint-disable-next-line
const env = (window as any)['env'] as { [key: string]: string };
export const environment: IEnvironment = {
    production: true,
    apiUrl: env['apiUrl'],
    instrumentationKey: env['instrumentationKey'],
    showVersion: env['showVersion'] === 'true',
    versionNumber: env['versionNumber'],
    azureB2cRedirectUrl: env['azureB2cRedirectUrl'],
    azureB2cClientId: env['azureB2cClientId'],
    azureB2cUrl: env['azureB2cUrl'],
    azureAdRedirectUrl: env['azureAdRedirectUrl'],
    azureAdClientId: env['azureAdClientId'],
    azureAdUrl: env['azureAdUrl'],
};
